import { Cliente } from "./cliente";
import { Pais } from "./pais";
import { Rol } from "./rol";

export class User {
    id?: string;
    username: string;
    password: string;
    nombre: string;
    apellido: string;
    email: string;
    token?: string;
    pais?: Pais;    
    cliente?: Cliente;    
    rol: Rol;
    activo: boolean;
    existente: boolean;
}